import httpClient from './httpClient';

const atributoService = {
  // Obtener todos los tipos de atributos
  async obtenerTiposAtributos() {
    try {
      const response = await httpClient.get('/atributos');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error al obtener tipos de atributos:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener tipos de atributos'
      };
    }
  },

  // Obtener configuración completa de una empresa
  async obtenerConfiguracionCompleta(empresaId) {
    try {
      const response = await httpClient.get(`/atributos/empresa/${empresaId}/configuracion`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error al obtener configuración completa:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener configuración completa'
      };
    }
  },

  // Obtener sub-atributos de una empresa (agrupados por tipo)
  async obtenerSubAtributosPorEmpresa(empresaId) {
    try {
      const response = await httpClient.get(`/atributos/empresa/${empresaId}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error al obtener sub-atributos por empresa:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener sub-atributos'
      };
    }
  },

  // Obtener sub-atributos de un tipo específico para una empresa
  async obtenerSubAtributosPorTipo(empresaId, atributoId) {
    try {
      const response = await httpClient.get(`/atributos/empresa/${empresaId}/tipo/${atributoId}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error al obtener sub-atributos por tipo:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener sub-atributos por tipo'
      };
    }
  },

  // Crear un nuevo sub-atributo
  async crearSubAtributo(atributoId, empresaId, nombre) {
    try {
      const response = await httpClient.post('/atributos/sub-atributos', {
        atributo_id: atributoId,
        empresa_id: empresaId,
        nombre: nombre
      });
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error al crear sub-atributo:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al crear sub-atributo',
        errors: error.response?.data?.errors
      };
    }
  },

  // Actualizar un sub-atributo
  async actualizarSubAtributo(subAtributoId, nombre) {
    try {
      const response = await httpClient.put(`/atributos/sub-atributos/${subAtributoId}`, {
        nombre: nombre
      });
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error al actualizar sub-atributo:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al actualizar sub-atributo',
        errors: error.response?.data?.errors
      };
    }
  },

  // Eliminar un sub-atributo
  async eliminarSubAtributo(subAtributoId) {
    try {
      const response = await httpClient.delete(`/atributos/sub-atributos/${subAtributoId}`);
      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error al eliminar sub-atributo:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al eliminar sub-atributo'
      };
    }
  }
};

export default atributoService; 